import { render, staticRenderFns } from "./MessageItem.vue?vue&type=template&id=3bdffadc&scoped=true&"
import script from "./MessageItem.vue?vue&type=script&lang=js&"
export * from "./MessageItem.vue?vue&type=script&lang=js&"
import style0 from "./MessageItem.vue?vue&type=style&index=0&id=3bdffadc&scoped=true&lang=css&"
import style1 from "./MessageItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdffadc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bogo\\we-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bdffadc')) {
      api.createRecord('3bdffadc', component.options)
    } else {
      api.reload('3bdffadc', component.options)
    }
    module.hot.accept("./MessageItem.vue?vue&type=template&id=3bdffadc&scoped=true&", function () {
      api.rerender('3bdffadc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Message/MessageItem.vue"
export default component.exports